<script>
  // @ts-check
  import { getTheme } from "../utilities/themes";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * The theme of the button used to determine if it is black or white.
   * @type {import('../utilities/themes').ThemeName}
   */
  export let theme = "white";

  /**
   * The text to be read by screen readers
   * @type {string}
   */
  export let accessibilityLabel = "Loading";

  /** @type { string } */
  let containerClass = "";
  export { containerClass as class };

  const currentTheme = getTheme(theme ?? "white");
  const dotColorValue = currentTheme.textColorValue;
  const backgroundColorValue = currentTheme.backgroundColorValue;
</script>

<span
  {id}
  class="flex w-6 items-center justify-center {containerClass}"
  style="--dot-color: {dotColorValue}; --bg-color: {backgroundColorValue};"
>
  <span class="loading" />
  <span class="sr-only">{accessibilityLabel}</span>
</span>

<style>
  .loading {
    width: 6px;
    aspect-ratio: 1;
    animation: dots 0.9s infinite linear;
  }

  @keyframes dots {
    0% {
      box-shadow:
        9px 0 var(--dot-color),
        -9px 0 var(--bg-color);
      background: var(--dot-color);
    }
    33% {
      box-shadow:
        9px 0 var(--dot-color),
        -9px 0 var(--bg-color);
      background: var(--bg-color);
    }
    66% {
      box-shadow:
        9px 0 var(--bg-color),
        -9px 0 var(--dot-color);
      background: var(--bg-color);
    }
    100% {
      box-shadow:
        9px 0 var(--bg-color),
        -9px 0 var(--dot-color);
      background: var(--dot-color);
    }
  }
</style>
